import { put } from "redux-saga/effects";
import { message } from "antd";

import ActivityApiCaller from "../../config/api/activityapicaller";

import { ContactViewerAction } from "../actions";

export default class ContactViewerMiddleware {
  static *getContactView({ payload, cb }) {
    try {
      const action =
        payload?.filter === "My Contact Viewers" ? "viewed" : "viewer";

      const res = yield ActivityApiCaller.Get(
        `/activity/contact-view/${action}?sort=${payload.sort ?? ""}`
      );

      if (res?.status === 200) {
        yield put(ContactViewerAction.getContactViewSuccess(res.data?.data));
      } else {
        yield put(ContactViewerAction.getContactViewFailure());
      }
      if (cb) {
        cb(res.data?.data);
      }
    } catch (err) {
      yield put(ContactViewerAction.getContactViewFailure());
    }
  }
  static *getAllContactView({ cb }) {
    try {
      const res = yield ActivityApiCaller.Get(
        `/activity/contact-view-all/viewer`
      );

      if (res?.status === 200) {
        yield put(ContactViewerAction.getAllContactViewSuccess(res.data?.data));
      }

      if (cb) {
        cb(res.data?.data);
      }
    } catch (err) {
      yield put(ContactViewerAction.getAllContactViewFailure());
    }
  }
  static *setContactView({ payload, cb }) {
    try {
      const res = yield ActivityApiCaller.Post(
        `/activity/contact-view`,
        payload
      );

      if (res.status === 200) {
        yield put(ContactViewerAction.setContactViewSuccess(res.data.data));
        message.success(res?.data?.message);
      } else {
        message.error(res?.data?.message);
        yield put(ContactViewerAction.setContactViewFailure());
      }
      if (cb) {
        cb(res.data.data);
      }
    } catch (err) {
      message.error("Something went wrong. Please try again.");
      yield put(ContactViewerAction.setContactViewFailure());
    }
  }
}
